import React from "react";
import Elemento4Drag, {TurnoTools4Drag} from "./Turno4Drag";
import {TurnoRecord} from "@commons/mapping/TurnoRecord";
import {GiustificativoRecord} from "@commons/mapping/GiustificativoRecord";
import Giustificativo4Drag from "./Giustificativo4Drag";
import {useDragDropManager} from "react-dnd";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import Azienda4Drag from "./Azienda4Drag";
import styles from "./Palettes.module.css";
import {ItemTypes} from "../../../core/DnDItemTypes";
import BasicBadge from "@components/BasicBadge";
import TooltipEx from "@components/Tooltip";

interface PaletteTurniProps {
    name: string,
    elementi: TurnoRecord[],
    //setElementiSelezionabili: React.Dispatch<React.SetStateAction<ElementoRMLSelezionabileRecord[]>>,
    //setElementiSelezionati: React.Dispatch<React.SetStateAction<ElementoRMLSelezionabileRecord[]>>,
    // onDrop: (arg: any, monitor: DropTargetMonitor) => void,
    // accept: string,
    type: string,
}

export const PaletteTurni: React.FC<PaletteTurniProps> = ({
                                                              name,
                                                              elementi,
                                                              type,
                                                          }) => {
    const dragDropManager = useDragDropManager();
    /**
     * Ordina per monte ore settimanale e descrizione
     * @param a
     * @param b
     */
    const compareElementi = (a: TurnoRecord, b: TurnoRecord) => {
        return TurnoRecord.compareDescrizioneDistribuzione(a, b);
    }
    const isActive = dragDropManager.getMonitor().isDragging();
    // Hotfix per rendere univoco il turno, la loader potrebbe caricare più volte le tabelle legate alle proprietà presenze, vedi <loadTabelleProprieta()> doppio for...
    /*
        const arrayUniqueByKey = elementi && elementi.length ? [...new Map(elementi.map(item =>
            [item.codTurno, item])).values()]:[];
    */
    const arrayUniqueByKey = elementi && elementi.length ? elementi : [];
    return (
        <div className={styles.palette}
             data-testid={name}>
            <div className="absolute top-3 left-0">
                <div className="inline-flex"><TurnoTools4Drag type={ItemTypes.TURNO_PENCIL}/><TurnoTools4Drag type={ItemTypes.TURNO_ERASER}/></div>
            </div>
            <div className={styles.title}>
                {/*{isActive ? 'Sposta il turno sulla giornata interessata!' : 'Palette orari/turni'}*/}
                Palette orari/turni
            </div>
            <div className={styles.body}>

                {arrayUniqueByKey.filter((item) => item.ggRicorsivita === 1 && item.usaInPianificazione).sort(compareElementi).map((item, index) => (
                    <Elemento4Drag key={item.codTurno} elemento={item} type={type}
                        /*setElementiSelezionabili={setElementiSelezionabili}*/
                        /*setElementiSelezionati={setElementiSelezionati}*/
                    />
                ))}
            </div>
        </div>
    )
};

interface PaletteGiustificativiProps {
    name: string,
    elementi: GiustificativoRecord[],
    //setElementiSelezionabili: React.Dispatch<React.SetStateAction<ElementoRMLSelezionabileRecord[]>>,
    //setElementiSelezionati: React.Dispatch<React.SetStateAction<ElementoRMLSelezionabileRecord[]>>,
    // onDrop: (arg: any, monitor: DropTargetMonitor) => void,
    // accept: string,
    type: string,
}

export const PaletteGiustificativi: React.FC<PaletteGiustificativiProps> = ({
                                                                                name,
                                                                                elementi,
                                                                                type,
                                                                            }) => {
    const dragDropManager = useDragDropManager();
    /**
     * Ordina per tipologia giustificativo e descrizione
     * @param a
     * @param b
     */
    const compareElementi = (a: GiustificativoRecord, b: GiustificativoRecord) => {
        if (a.tipoGiu === b.tipoGiu) {
            return a.descrizione!.localeCompare(b.descrizione!);
        } else return a.tipoGiu! < b.tipoGiu! ? -1 : 1;
    }
    const isActive = dragDropManager.getMonitor().isDragging();
    return (
        <div className={styles.palette}
             data-testid={name}>
            <div className="absolute top-3 left-0">
                <TooltipEx tooltip="Porta il mouse sulla giornata da editare e premi Click per aprire il pannello Giustificativi">
                    <BasicBadge label="?" type="custom" customStyle={{bg: 'bg-yellow-300', text: "text‑current"}}></BasicBadge>
                </TooltipEx>
            </div>
            <div className={styles.title}>
                Palette giustificativi
            </div>
            <div className={styles.body}>
                {elementi && elementi.filter((item) => item.tipoGiu === 'O'
                    && item.usaInPianificazione
                    && (item.tipoAutomatismo === 0 || item.tipoAutomatismo === 3)).sort(compareElementi).map((item, index) => (
                    <Giustificativo4Drag key={item.codGiu} elemento={item} type={type}
                        /*setElementiSelezionabili={setElementiSelezionabili}*/
                        /*setElementiSelezionati={setElementiSelezionati}*/
                    />
                ))}
            </div>
        </div>
    )
};

interface PaletteAziendeProps {
    name: string,
    elementi: AziendaRecord[],
    //setElementiSelezionabili: React.Dispatch<React.SetStateAction<ElementoRMLSelezionabileRecord[]>>,
    //setElementiSelezionati: React.Dispatch<React.SetStateAction<ElementoRMLSelezionabileRecord[]>>,
    // onDrop: (arg: any, monitor: DropTargetMonitor) => void,
    // accept: string,
    type: string,
}

export const PaletteAziende: React.FC<PaletteAziendeProps> = ({
                                                                  name,
                                                                  elementi,
                                                                  type,
                                                              }) => {
    const dragDropManager = useDragDropManager();
    /**
     * Ordina per descrizione unità locale
     * @param a
     * @param b
     */
    const compareElementi = (a: AziendaRecord, b: AziendaRecord) => {
        return a.unitaLocale!.localeCompare(b.unitaLocale!);
    }
    const isActive = dragDropManager.getMonitor().isDragging();
    return (
        <div className={styles.palette} data-testid={name}>
            <div className="absolute top-3 left-0">
                <TooltipEx tooltip="Porta il mouse sulla giornata da editare e premi CTRL+Click per aprire il pannello Unità Locali">
                    <BasicBadge label="?" type="custom" customStyle={{bg: 'bg-red-300', text: "text‑current"}}></BasicBadge>
                </TooltipEx>
            </div>
            <div className={styles.title}>
                Palette Unità locali
            </div>
            <div className={styles.body}>
                {elementi && elementi.sort(compareElementi).map((item, index) => (
                    <Azienda4Drag key={item.idAzienda} elemento={item} type={type}
                        /*setElementiSelezionabili={setElementiSelezionabili}*/
                        /*setElementiSelezionati={setElementiSelezionati}*/
                    />
                ))}
            </div>
        </div>
    )
};